<script setup lang="ts">
import type { DropdownMenuProps } from '@nuxt/ui';
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import DButton from '#layers/ui/components/Button.vue';
import { mergeUi } from '#layers/ui/utils/merge-ui';
import DDropdownMenu from '#ui/components/DropdownMenu.vue';

defineOptions({
	name: 'OverflowMenu',
});

defineProps<{
	items: DropdownMenuProps['items'];
	triggerUi?: ButtonProps['ui'];
	trigger?: Omit<ButtonProps, 'ui'> & Record<string, any>;
	ui?: DropdownMenuProps['ui'];
	disabled?: boolean;
}>();
</script>

<template>
	<DDropdownMenu v-slot="{ open }" :items :disabled :ui>
		<slot :open>
			<DButton
				color="neutral"
				variant="ghost"
				square
				icon="lucide:ellipsis"
				class="text-muted hover:text-highlighted focus-visible:text-highlighted"
				:class="{
					'bg-elevated': open,
				}"
				:ui="mergeUi({ leadingIcon: 'size-4' }, triggerUi)"
				:aria-label="$t('common.open_menu')"
				data-test-id="overflow-menu"
				v-bind="trigger"
				@click.stop
			/>
		</slot>
	</DDropdownMenu>
</template>
